import React, { Component } from 'react';
import { Modal, InputNumber, message, Spin } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class SetScaleFactor extends Component {
    state = {
        visible: false,
        loading: false,
        key: '',
        activeKey: '',
        ratioCoefficient: 1,
        title: '',
    }

    show = (key, visitData = {}, activeKey) => {
        const { quotationVisitDataId, quotationFteDataId, ratioCoefficient, clinicalQuotationRecordId } = visitData;
        const text = key === 'DATA_TYPE_PROJECT_MANAGER' ? 'FTE/月' : 'FTE/月/中心';
        this.setState({
            key,
            activeKey,
            clinicalQuotationRecordId,
            quotationVisitDataId,
            quotationFteDataId,
            ratioCoefficient: ratioCoefficient ? ratioCoefficient : 1,
            visible: true,
            title: activeKey == 'ServiceQuotationDetail' ? `比例系数设置后，${text}会直接*该比例系数` : '比例系数设置后，单价/工时会直接*该比例系数',
        });
    }

    hide = () => {
        this.setState({
            params: {},
            visible: false,
        });
    }

    submit = () => {
        const { ratioCoefficient, quotationVisitDataId, quotationFteDataId, key, clinicalQuotationRecordId, activeKey } = this.state;
        if (!ratioCoefficient) {
            message.warning('请输入比例系数');
            return;
        }
        this.setState({ loading: true });
        const url = activeKey == 'ServiceQuotationDetail' ? API_URL.evaluate.setFteDataRate : API_URL.evaluate.setVisitDataRate;
        const options = {
            method: 'POST',
            url,
            data: { 
                clinicalQuotationRecordId,
                quotationVisitDataId,
                quotationFteDataId,
                dataType: key,
                ratioCoefficient,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(clinicalQuotationRecordId, activeKey);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = value => {
        this.setState({ ratioCoefficient: value });
    }

    getContent = () => {
        const { ratioCoefficient, title } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div style={{ padding: '5px 60px' }}>{title}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}比例系数:</div>
                    <div className="item-right">
                        <InputNumber
                            placeholder='请输入'
                            style={{ width: 180 }}
                            min={0}
                            precision={2}
                            step={0.01}
                            value={ratioCoefficient}
                            onChange={this.handleChange}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const {  visible, loading } = this.state;
        return (
            <Modal
                title={'设置比例系数'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default SetScaleFactor;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/SetScaleFactor.js